var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 490,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.767 0h178.466c10.699 0 14.578 1.114 18.49 3.206 3.91 2.091 6.98 5.16 9.071 9.072 2.092 3.911 3.206 7.79 3.206 18.489v428.466c0 10.699-1.114 14.578-3.206 18.49-2.091 3.91-5.16 6.98-9.072 9.071-3.911 2.092-7.79 3.206-18.489 3.206H30.767c-10.699 0-14.578-1.114-18.49-3.206-3.91-2.091-6.98-5.16-9.071-9.072C1.114 473.811 0 469.932 0 459.233V30.767c0-10.699 1.114-14.578 3.206-18.49 2.091-3.91 5.16-6.98 9.072-9.071C16.189 1.114 20.068 0 30.767 0z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.5,
    x: 11,
    y: 63,
    width: 218,
    height: 132,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 286h218v4H11zM11 296h147v4H11z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 306h175v4H11zM11 316h109v4H11z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 413h92v4H11zM11 423h62v4H11z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 413h92v4h-92zM132 423h62v4h-62z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDD",
    opacity: 0.5,
    strokeLinecap: "square",
    d: "M240 332.5H0M240 440.5H0M240 205.5H0"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.5,
    x: 11,
    y: 343,
    width: 96,
    height: 60,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.5,
    x: 133,
    y: 343,
    width: 96,
    height: 60,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.5,
    x: 11,
    y: 216,
    width: 218,
    height: 60,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDD",
    opacity: 0.5,
    strokeLinecap: "square",
    d: "M120.5 332.5v108"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDD",
    strokeLinecap: "square",
    d: "M240 52.5H0"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#DDD",
    fill: "#EEE",
    x: 11.5,
    y: 21.5,
    width: 217,
    height: 21,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "LucidaGrande, Lucida Grande",
    fontSize: 9,
    fill: "#AAA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 79.889,
    y: 34
  }, "www.website.com")))));
}
export default SvgMobilePlaceholder;